<template>
  <div class="mt-4">
    <div class="d-flex border-bottom" v-for="(feature, index) in additionalFeaturesDetails" :key="index">
      <div class="p-2">
        <span class="align-middle">{{ feature.name }}</span>
        <custom-tooltip
          :index="index"
          :css-class="['align-middle', 'pointer', 'ml-1']"
          :section="'additional-features'"
          :tooltipText="feature.description"
        ></custom-tooltip>
      </div>
      <div class="ml-auto p-2">
        <b-form-radio class="align-middle" v-model="feature.value" :value="true" disabled>
          <span :class="[(feature.value ? 'feature-present' : '', 'align-middle feature-radio-label')]">
            {{ feature.value ? $t('common.present') : $t('common.absent') }}
          </span>
        </b-form-radio>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTooltip from '../../components/Lib/CustomTooltip.vue'

export default {
  components: {
    CustomTooltip,
  },
  props: {
    additionalFeaturesDetails: {},
  },
}
</script>

<style lang="scss" scoped>
.fa-question-circle {
  color: var(--primary);
}

.feature-present {
  color: var(--primary) !important;
}
</style>
